export enum StopAreaType {
  Unknown = 'unknown',
  Home = 'home',
  Work = 'work',
}
